import * as React from 'react';

function LogoSVG({ ref, ...props }: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 43 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
			<path d="M7.28571 0H13V5.71429H7.28571V0Z" />
			<path d="M0.142853 7.14282H5.85714V12.8571H0.142853V7.14282Z" />
			<path d="M14.4286 7.14282H20.1428V12.8571H14.4286V7.14282Z" />
			<path d="M25.8571 0H31.5714V5.71429H25.8571V0Z" />
			<path d="M37.2857 0H43V5.71429H37.2857V0Z" />
			<path d="M37.2857 7.14282H43V12.8571H37.2857V7.14282Z" />
			<path d="M7.28571 14.2856H13V19.9999H7.28571V14.2856Z" />
			<path d="M14.4286 5.71429V0C16.0952 0 19.5714 1.14286 20.1428 5.71429H14.4286Z" />
			<path d="M14.4286 14.2856H20.1429C20.1429 15.9523 19 19.4285 14.4286 19.9999V14.2856Z" />
			<path d="M25.8571 14.2856H31.5714C31.5714 15.9523 30.4286 19.4285 25.8571 19.9999V14.2856Z" />
			<path d="M37.2857 14.2856H43C43 15.9523 41.8571 19.4285 37.2857 19.9999V14.2856Z" />
			<path d="M5.85715 14.2857L5.85715 20C4.19048 20 0.71429 18.8571 0.142862 14.2857L5.85715 14.2857Z" />
			<path d="M5.85714 5.71436L0.142853 5.71436C0.142853 4.04769 1.28571 0.571498 5.85714 7.01178e-05L5.85714 5.71436Z" />
		</svg>
	);
}

export { LogoSVG };
